var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTopologyWirelessLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 22,
    viewBox: "0 0 60 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12H0V10H4V12ZM12 12H8V10H12V12ZM20 12H16V10H20V12ZM28 12H24V10H28V12ZM36 12H32V10H36V12ZM44 12H40V10H44V12ZM52 12H48V10H52V12ZM60 12H56V10H60V12Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTopologyWirelessLine);
export default __webpack_public_path__ + "static/media/icn_topology_wireless_line.363a98a0e19688f06e8e4ee2403606b1.svg";
export { ForwardRef as ReactComponent };